<template>
  <div class="text-label-large flex flex-row items-center gap-3">
    <div
      v-for="perspective in displayedPerspectives"
      :key="perspective.id"
      class="flex flex-row items-center gap-1"
    >
      <div class="relative h-4 w-4">
        <PerspectiveShape :perspective="perspective" :allPerspectives="allPerspectives" />
      </div>
      <span class="text-label-large">{{ labelFor(perspective) }}</span>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import type { Perspective } from '@/core/models/perspective'
  import { resolvePerspectiveLabel } from '@/core/models/perspective-label'
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import PerspectiveShape from './PerspectiveShape.vue'

  interface Props {
    allPerspectives: ReadonlyArray<Perspective>
    perspectives?: ReadonlyArray<Perspective | string>
    count?: number
  }

  const props = defineProps<Props>()
  const { t } = useI18n()

  const displayedPerspectives = computed(() => {
    if (props.perspectives) {
      return props.perspectives.map((p) => {
        if (typeof p === 'string') {
          return props.allPerspectives.find((pr) => pr.key === p)!
        }
        return p
      })
    }
    return props.allPerspectives
  })

  const labelFor = (perspective: Perspective) =>
    resolvePerspectiveLabel(perspective.key, props.allPerspectives, {
      kind: 'nameShort',
      count: props.count === undefined ? 2 : props.count,
      selfLabel: t('perspectives.self-short', { count: 1 }),
    })
</script>
